import { render, staticRenderFns } from "./staff_documents.vue?vue&type=template&id=3d18189f&scoped=true&"
import script from "./staff_documents.vue?vue&type=script&lang=js&"
export * from "./staff_documents.vue?vue&type=script&lang=js&"
import style0 from "./staff_documents.vue?vue&type=style&index=0&id=3d18189f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18189f",
  null
  
)

export default component.exports